import { NgCasinoAnalytics } from "../analytics/analytics-ng-casino";
import { ngFrameworkLoaded } from "@sazka/ng/ng-integration";
import { debounce } from "@sazka/utils/debounce";
import { ResponsiveUtils } from "@sazka/utils/responsive-utils";
import { computed, onMounted, onUnmounted, ref } from "vue";

const MOBILE_BREAKPOINT = 1007;
const viewportWidth = ref<number>(window.innerWidth);

const isMobile = computed(() => {
    return viewportWidth.value < MOBILE_BREAKPOINT;
});

const updateSize = () => {
    viewportWidth.value = window.innerWidth;
};

const debouncedUpdateSize = debounce(updateSize, 50);

export function useNgCasinoUtils() {
    const startDeposit = async (codeName: string) => {
        NgCasinoAnalytics.pushDepositClick(codeName);
        await ngFrameworkLoaded();
        ng_fw.showDeposit();
    };

    const openFullscreenMode = async () => {
        if (!document.fullscreenElement) {
            try {
                await document.documentElement.requestFullscreen({ navigationUI: "hide" });
            } catch (error) {
                console.error("Failed to enter fullscreen mode:", error);
            }
        }
    };

    const handleFullscreen = () => {
        if (ResponsiveUtils.isMobile() && !ResponsiveUtils.isIos()) {
            openFullscreenMode();
        }
    };

    const registerHooks = () => {
        onMounted(() => {
            updateSize();
            window.addEventListener("resize", debouncedUpdateSize);
        });

        onUnmounted(() => {
            window.removeEventListener("resize", debouncedUpdateSize);
        });
    };

    return {
        isMobile,
        viewportWidth,
        registerHooks,
        startDeposit,
        handleFullscreen,
    };
}
